// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation RefreshUpsTrackingMutation($input: RefreshUpsTrackingInput!) {
    refreshUpsTracking(input: $input) {
      trackingEvents {
        id
        status
        description
        location
        eventTimestamp
        createdAt
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
